// Vincula la foto al nombre que figura en la lista (no al id del producto),
// así si se borra la lista o el producto, el archivo conserva el nombre.

// Reemplaza los caracteres que rompen las URLs o los nombres de archivo de
// Windows, pero conserva espacios, acentos, paréntesis y comas para que el
// nombre se lea igual que en la lista.
const sanearNombre = (nombre) => String(nombre || '')
  .trim()
  .replace(/[\\/?%#&+:*"<>|=]/g, '-')
  .replace(/\s+/g, ' ')
  .replace(/[.\s]+$/, '');

// Devuelve "iPhone 15 128 GB.jpg" a partir del nombre del producto y el archivo
// subido (usa su extensión; si no tiene, cae en .jpg).
export const nombreArchivoImagen = (nombre, file) => {
  const extRaw = String((file && file.name ? file.name : '') || '')
    .split('.')
    .pop()
    .toLowerCase();
  const ext = /^[a-z0-9]{1,5}$/.test(extRaw) ? extRaw : 'jpg';
  const base = sanearNombre(nombre);
  return base ? `${base}.${ext}` : `imagen.${ext}`;
};
